const seoDefault = (param: {
  title: string;
  description: string;
  thumbnail?: string;
}) => {
  const title = param.title || 'Mysoalan';
  const description =
    param.description ||
    'MySoalan adalah satu platform untuk cikgu dan pelajar mendapatkan bahan mengajar, latihan dan soalan.';
  const thumbnail =
    param.thumbnail ||
    'https://mysoalan-prod-v2.s3.ap-southeast-1.amazonaws.com/thumbnail.jpg';

  return [
    {
      name: 'title',
      vmid: 'title',
      content: title,
    },
    {
      name: 'description',
      vmid: 'description',
      content: description,
    },
    //
    {
      property: 'og:title',
      content: title,
      vmid: 'og:title',
    },
    {
      property: 'og:description',
      content: description,
      vmid: 'og:description',
    },
    {
      property: 'og:image',
      content: thumbnail,
      vmid: 'og:image',
    },
    {
      property: 'og:url',
      content: window.location.href,
      vmid: 'og:url',
    },
    //
    {
      name: 'twitter:title',
      content: title,
      vmid: 'twitter:title',
    },
    {
      name: 'twitter:description',
      content: description,
      vmid: 'twitter:description',
    },
    {
      name: 'twitter:image',
      content: thumbnail,
      vmid: 'twitter:image',
    },
    {
      name: 'twitter:url',
      content: window.location.href,
      vmid: 'twitter:url',
    },
  ];
};

export default seoDefault;
